import { Component, Inject, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { firstValueFrom, Observable } from 'rxjs'
import { FirebaseLemonator } from '../_angular/service/firebase-lemonator.service'
import { AsiakkaanMaksutapa, AsiakkaanMaksutapaHistoria } from '../_jaettu-lemonator/model/asiakas'
import { KirjanpitajanNimitiedot } from '../_jaettu-lemonator/model/kirjanpitaja'
import { KirjanpitoJaettuService } from '../_jaettu-lemonator/service/kirjanpito-jaettu.service'

export interface AsiakkaanMaksutavatHistoriaDialogData {
  asiakasAvain: string
  maksutapa: AsiakkaanMaksutapa
  kirjanpitajienNimitiedotMapObservable: Observable<Map<string, KirjanpitajanNimitiedot>>
}

interface ViewableHistoria extends AsiakkaanMaksutapaHistoria {
  tyypinNimi: string
  paivittajanNimi: string
}

@Component({
  templateUrl: './asiakkaan-maksutavat.historia.dialog.html',
  styleUrls: ['./asiakkaan-maksutavat.historia.dialog.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakkaanMaksutavatHistoriaDialog implements OnInit {
  readonly historia = signal<ViewableHistoria[]>([])
  readonly loading = signal(true)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AsiakkaanMaksutavatHistoriaDialogData,
    private _dialogRef: MatDialogRef<AsiakkaanMaksutavatHistoriaDialog>,
    private _firebaseLemonator: FirebaseLemonator,
    private _kirjanpitoJaettuService: KirjanpitoJaettuService,
  ) {}

  async ngOnInit() {
    await this.loadHistory()
  }

  async loadHistory() {
    this.loading.set(true)

    try {
      const historiaPromise = this._firebaseLemonator
        .firestoreCollection<AsiakkaanMaksutapaHistoria>(`asiakkaat/${this.data.asiakasAvain}/maksutavat/${this.data.maksutapa.avain}/maksutavat-historia`)
        .orderBy('paivitetty', 'desc')
        .get()

      const kirjanpitajienNimitiedotMapPromise = firstValueFrom(this.data.kirjanpitajienNimitiedotMapObservable)

      const [historia, kirjanpitajienNimitiedotMap] = await Promise.all([historiaPromise, kirjanpitajienNimitiedotMapPromise])
      this.historia.set(
        historia.map(item => {
          if (item.paivittaja === 'lemonator_system') {
            return {
              ...item,
              tyypinNimi: this._kirjanpitoJaettuService.annaMaksutavanLuontityypinNimi(item.kirjauksienLuontityyppi, item.sahkoisenTiliotteenAlatyyppi),
              paivittajanNimi: 'Lemonatorin taustajärjestelmä',
            }
          }

          const paivittaja = kirjanpitajienNimitiedotMap.get(item.paivittaja)
          const paivittajanNimi = paivittaja ? paivittaja.etunimi + ' ' + paivittaja.sukunimi : 'Tuntematon'
          return {
            ...item,
            tyypinNimi: this._kirjanpitoJaettuService.annaMaksutavanLuontityypinNimi(item.kirjauksienLuontityyppi, item.sahkoisenTiliotteenAlatyyppi),
            paivittajanNimi: paivittajanNimi,
          }
        }),
      )
    } catch (error) {
      console.error('Error loading maksutapa history:', error)
    } finally {
      this.loading.set(false)
    }
  }

  close() {
    this._dialogRef.close()
  }
}
